export const executionAnalyticsPageTypeMap = {
    task: {
        communication: {
            execution: 'Task:Communication:Execution',
            release: 'Task:Communication:Release',
            approval: 'Task:Communication:Approval',
        },
        pm: {
            execution: 'Task:PictureManagement:Execution',
            release: 'Task:PictureManagement:Release',
            approval: 'Task:PictureManagement:Approval',
        },
        photographic: {
            execution: 'Task:PictureManagement:Execution',
            release: 'Task:PictureManagement:Release',
            approval: 'Task:PictureManagement:Approval',
        },
        svt: {
            execution: 'Task:StoreVisit:Execution',
            release: 'Task:StoreVisit:Release',
            approval: 'Task:StoreVisit:Approval',
        },
    },
    news: {
        communication: {
            execution: 'News:Communication:Execution',
            release: 'News:Communication:Release',
            approval: 'News:Communication:Approval',
        },
    },
    visit: {
        svt: {
            execution: 'Task:StoreVisit:Execution',
            release: 'Task:StoreVisit:Release',
            approval: 'Task:StoreVisit:Approval',
        },
    },
}

export const creationAnalyticsPageTypeMap = {
    task: {
        communication: {
            edit: 'Task:Communication:Edit',
            history: 'Task:Communication:HistoryChange',
        },
        pm: {
            edit: 'Task:Photographic:Edit',
            history: 'Task:Photographic:HistoryChange',
        },
        svt: {
            edit: 'Task:StoreVisit:Edit',
            history: 'Task:StoreVisit:HistoryChange'
        },
        serviceRequest: {
            edit: 'Task:ServiceRequest:Edit',
            history: 'Task:ServiceRequest:HistoryChange'
        },
    },
    news: {
        communication: {
            edit: 'News:Communication:Edit',
            history: 'News:Communication:HistoryChange',
        },
    },
    visit: {
        svt: {
            edit: 'Task:StoreVisit:Edit',
            history: 'Task:StoreVisit:HistoryChange',
        },
    },
}
